/**
 * The release an RSW version belongs to, combining major and minor (ignoring patch and any suffix), with
 * leading zeros dropped: so `2025.1.0-b12`, `2025.01.1`, `2025.1.13`, `2025.1.3-12` and the older
 * `2025.01~03.12` all read as one `2025.1`. A version without a numeric `major.minor` prefix is its own release.
 */
export const rswVersionGroup = (version: string) => {
  const match = version.trim().match(/^(\d+)\.(\d+)/);
  if (!match) return version;

  const [, major, minor] = match;
  return `${Number(major)}.${Number(minor)}`;
};
